const getters = {
  SessionId: state => state.user.userInfo.SessionId,
  UserId:state => state.user.userInfo.UserId,
  UserInfo:state => state.user.userInfo,
  DeviceID:state => state.user.userInfo.DeviceID,
  UserName:state => state.user.userInfo.UserName,
  Role:state => state.user.userInfo.RoleData,
  GatewayCode:state => state.user.userInfo.GatewayCode,
}
export default getters
